/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getEvent = /* GraphQL */ `
  query GetEvent($id: ID!) {
    getEvent(id: $id) {
      id
      name
      athleteName
      registrationOpen
      registrationClose
      startDate
      endDate
      addressOne
      addressTwo
      city
      zip
      state
      cost
      refundPolicy
      contact
      description
      bannerImage
      athleteImage
      sport
      slug
      registrationURL
      startTime
      endTime
      createdAt
      updatedAt
    }
  }
`;
export const listEvents = /* GraphQL */ `
  query ListEvents(
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        athleteName
        registrationOpen
        registrationClose
        startDate
        endDate
        addressOne
        addressTwo
        city
        zip
        state
        cost
        refundPolicy
        contact
        description
        bannerImage
        athleteImage
        sport
        slug
        registrationURL
        startTime
        endTime
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getContact = /* GraphQL */ `
  query GetContact($id: ID!) {
    getContact(id: $id) {
      id
      firstName
      lastName
      school
      sport
      phone
      referral
      message
      email
      createdAt
      updatedAt
    }
  }
`;
export const listContacts = /* GraphQL */ `
  query ListContacts(
    $filter: ModelContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        school
        sport
        phone
        referral
        message
        email
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEventBySlug = /* GraphQL */ `
  query GetEventBySlug(
    $slug: String
    $sortDirection: ModelSortDirection
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getEventBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        athleteName
        registrationOpen
        registrationClose
        startDate
        endDate
        addressOne
        addressTwo
        city
        zip
        state
        cost
        refundPolicy
        contact
        description
        bannerImage
        athleteImage
        sport
        slug
        registrationURL
        startTime
        endTime
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
